import { getPlanDraftTotals } from "../nutritionPlanLogic";

export function getNutritionPlanObjectiveTotals(
  draft,
  selectedOptionIdsByMeal = null,
) {
  return getPlanDraftTotals(draft, selectedOptionIdsByMeal);
}

export function resolveNutritionPlanDisplayedTotals({
  currentTotals = null,
  loadingFallbackTotals = null,
  isCurrentTotalsLoading = false,
} = {}) {
  if (!isCurrentTotalsLoading) {
    return currentTotals;
  }

  if (loadingFallbackTotals && typeof loadingFallbackTotals === "object") {
    return loadingFallbackTotals;
  }

  return null;
}
